import i18n from "@/i18n";
import { format, isDate, isValid } from "date-fns";
import type { Nullish } from "@/types/CommonTypes";

import type { Rate } from "@/components/faq/FaqItem.vue";

const { t } = i18n.global;

// TODO: Function copied from dashboard. Remove once moved to monorepo
export function formatMoney(
  value: number | string | null | undefined,
  currency: "USD" | "CAD" = "USD",
  minimumFractionDigits = 0
) {
  const parsedValue = parseFloat(`${value}`);
  if (Number.isNaN(parsedValue)) {
    return "";
  }
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits,
    currencyDisplay: "symbol",
  });
  return formatter.format(parsedValue);
}

// TODO: Function copied from dashboard. Remove once moved to monorepo
export function formatPercentage(value: number | string | null | undefined, decimals = 0) {
  const numberValue = parseFloat(`${value}`);

  if (!value || String(value) === "0" || Number.isNaN(numberValue)) {
    return "0%";
  }

  if (Math.round(numberValue) == value) {
    return `${value}%`;
  }
  return `${numberValue.toFixed(decimals)}%`;
}

// TODO: Function copied from dashboard. Remove once moved to monorepo
export const formatDate = (
  value: string | number | Date | Nullish,
  pattern = "MM/dd/yyyy",
  perTimeZone = false
) => {
  if (value === null || value === undefined || value === "" || !isValid(new Date(value))) {
    return "-";
  }
  const date = (isDate as (dateVal: NonNullable<typeof value>) => dateVal is Date)(value)
    ? value
    : new Date(value);

  return format(
    new Date(date.getTime() + (perTimeZone ? 0 : date.getTimezoneOffset()) * 60000),
    pattern
  );
};

export const buildSlackFeedbackMessage = ({
  question,
  rate,
  feedback,
  author,
}: {
  question: string;
  rate: Rate;
  feedback: string;
  author: string;
}) => {
  return `:alphabet-yellow-question: *${question}*\n\n:thumbs${rate}: "_${feedback}_"\n\n:email: ${author}`;
};

const formatFileSize = (
  sizeInKilobytes: number | string | null | undefined
): { unit: string; size: number } =>
  !sizeInKilobytes
    ? { unit: "KB", size: 0 }
    : Number(sizeInKilobytes) > 1024
      ? {
          unit: "MB",
          size: Number(
            `${Math.round(parseFloat(`${sizeInKilobytes}`) / 1024)}`.replace(
              /\B(?=(\d{3})+(?!\d))/g,
              "."
            )
          ),
        }
      : {
          unit: "KB",
          size: Math.round(parseFloat(`${sizeInKilobytes}`)),
        };

export const formatDocumentListFileSize = (originalSize: number): string => {
  const { size, unit } = formatFileSize(originalSize / 1024); // bytes to kbytes

  if (size === 0) {
    return "";
  }

  return t(`documents.fileSizes.${unit.toLowerCase()}`, { size });
};
